import React from 'react'
import cn from 'classnames'

import './Button.less'

type ButtonVariant = 'default' | 'primary'

type ButtonOwnProps<C extends React.ElementType = 'button'> = {
  variant?: ButtonVariant
  as?: C
}

type ButtonProps<C extends React.ElementType = 'button'> = ButtonOwnProps<C> &
  Omit<React.ComponentPropsWithRef<C>, keyof ButtonOwnProps>

function Button<C extends React.ElementType = 'button'>({
  variant = 'default',
  as,
  className,
  children,
  ...rest
}: ButtonProps<C>) {
  const Tag = as || 'button'
  return (
    <Tag className={cn('btn', `btn-${variant}`, className)} {...rest}>
      {children}
    </Tag>
  )
}

export default Button
